<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCBenefits :h2="this.h2" :h3="this.h3" :benefits="this.benefits" />
  </div>
</template>

<script>
import FCBenefits from "@/components/patterns/FCBenefits";
import Chair from "@/assets/icons/benefits/chair.svg";
export default {
  components: {
    FCBenefits,
    Chair
  },
  mounted() {
    const ref = this.$store.state.menu.cincinnatusClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.cincinnatusClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.cincinnatusClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Cincinnatus Club",
      h3: "Benefits",
      benefits: [
        {
          icon: "chair.png",
          text: `Lounge-style padded seats`
        },
        {
          icon: "plate.png",
          text: `Premium food and drink available for purchase from private food concepts within the club`
        },
        {
          icon: "car.png",
          text: `Reserved, on site parking available for purchase`
        },
        {
          icon: "umbrella.png",
          text: `Covered lower bowl seating and sightlines on the west side `
        },
        {
          icon: "club.png",
          text: `Private indoor club`
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cincinnatus-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>